fragment FeaturesRotationFragment on featuresRotation_Entry {
  typeHandle
  heading
  guestOnly
  featureCards {
    ... on featureCardsBlock_Entry {
      heading
      body
    }
  }
}
